<template>
  <div class="indicator withdrawn-indicator">
    <svg height="30" viewBox="0 0 60 60" width="30" xmlns="http://www.w3.org/2000/svg"><path style="fill: #9f4c4c; fill-rule: evenodd;" d="M100,390a30,30,0,1,1,30-30A30,30,0,0,1,100,390Zm18-30a4,4,0,0,1-4,4H86a4,4,0,0,1,0-8h28A4,4,0,0,1,118,360Z" id="remove" transform="translate(-70 -330)"/></svg>
  </div>
</template>

<script>
export default {
  name: 'WithdrawnIndicator'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/display/WithdrawnIndicator.vue